import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const checkboxSlotRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'label'],
  base: {
    root: defineStyle({
      cursor: 'pointer',
    }),
    control: defineStyle({
      w: 'var(--checkbox-size)',
      h: 'var(--checkbox-size)',
      transitionProperty: 'box-shadow',
      transitionDuration: 'normal',
      border: '2px solid',
      borderRadius: 'sm',
      borderColor: 'inherit',
      color: 'gray.300',
      _checked: {
        bg: 'gray.500',
        borderColor: 'gray.500',
        color: 'white',
        _hover: { bg: 'gray.600', borderColor: 'gray.600' },
        _disabled: {
          borderColor: 'gray.200',
          bg: 'gray.200',
          color: 'gray.500',
        },
      },
      _indeterminate: {
        bg: 'gray.500',
        borderColor: 'gray.500',
        color: 'white',
      },
      _disabled: { bg: 'gray.100', borderColor: 'gray.100' },
      _focusVisible: { boxShadow: 'outline' },
      _invalid: { borderColor: 'red.500' },
    }),
    label: defineStyle({
      userSelect: 'none',
      fontWeight: 'normal',
      _disabled: { opacity: 0.4 },
    }),
  },
  variants: {
    variant: {
      reversed: {
        root: defineStyle({
          flexDirection: 'row-reverse',
        }),
      },
    },
  },
});

export default checkboxSlotRecipe;
